import { render } from "./Signup.vue?vue&type=template&id=2012ccd0&scoped=true"
const script = {}

import "./Signup.vue?vue&type=style&index=0&id=2012ccd0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2012ccd0"

export default script